<template>
  <form-field v-bind="$attrs" :title="title" is-link :is-require="isRequire" @click="onClick">
    <div v-if="!value" class="placeholder">请输入{{ title }}</div>
    <div v-else class="text-wrap">{{ value }}</div>

    <van-popup v-model="isShow" round class="textarea-popup" get-container="body" position="bottom" safe-area-inset-bottom close-on-popstate lock-scroll @closed="onClosed">
      <div class="nav-bar">
        <div class="nav-bar-left" @click="onBack">取消</div>
        <div class="nav-bar-title">{{ title }}</div>
        <div class="nav-bar-right" @click="onSave">确定</div>
      </div>
      <div class="content">
        <div class="input-area" :style="{ paddingBottom: showWordLimit ? '50px' : '' }">
          <div v-if="!content.length" class="placeholder">
            <ul v-if="type === 'position'">
              <li>请输入您所提供的服务描述，如：擅长领域、工作经验等</li>
            </ul>
            <span v-else>请输入{{ title }}</span>
          </div>
          <textarea v-model="content" class="input-control" :maxlength="maxlength"></textarea>
          <div v-if="showWordLimit" class="counter">{{ content.length }}/{{ maxlength }}</div>
        </div>
      </div>
    </van-popup>
  </form-field>
</template>
<style scoped lang="less">
.placeholder {
  font-size: 32px;
  color: #bbb;
}
.text-wrap {
  line-height: 48px;
  color: #444;
  word-wrap: break-word;
  word-break: break-all;
  white-space: pre-wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.textarea-popup {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 72%;
  overflow: hidden;
  .nav-bar {
    flex-shrink: 0;
    position: relative;
    height: 100px;
    background-color: #fff;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #edeef2;
    .nav-bar-left,
    .nav-bar-right {
      position: absolute;
      top: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      padding: 0 32px;
      font-size: 28px;
    }
    .nav-bar-left {
      left: 0;
      color: #999;
    }
    .nav-bar-right {
      right: 0;
      color: #e84c3d;
    }
    .nav-bar-title {
      max-width: 60%;
      margin: 0 auto;
      color: #333;
      font-weight: 500;
      font-size: 36px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .footer {
    flex-shrink: 0;
    padding: 20px 0;
    overflow-x: auto;
    white-space: nowrap;
    font-size: 0;
    border-top: 1px solid #f1f2f6;
    > div {
      display: inline-block;
      padding: 5px 10px;
      background-color: #f4f4f5;
      border: 1px solid #e9e9eb;
      color: #909399;
      margin-right: 16px;
      font-size: 24px;
      border-radius: 4px;

      &:first-child {
        margin-left: 40px;
      }

      &:last-child {
        margin-right: 40px;
      }
    }
    .active {
      background-color: #ecf5ff;
      color: #409eff;
      border: 1px solid #d9ecff;
    }
  }
  .content {
    padding: 40px;
    flex: 1;
  }
  .title-area {
    padding: 40px 0;
    .title {
      font-size: 46px;
      font-weight: 500;
      color: #222;
    }
    .sub-title {
      margin-top: 24px;
      font-size: 26px;
      color: #666;
    }
  }

  .input-area {
    position: relative;
    width: 100%;
    height: 420px;
    background-color: transparent;
    border-radius: 4px;
    .placeholder {
      position: absolute;
      z-index: -1;
      color: #ccc;
      font-size: 32px;
    }
    .input-control {
      font-size: 32px;
      border: 0;
      resize: none;
      display: block;
      box-sizing: border-box;
      width: 100%;
      margin: 0;
      color: #333;
      line-height: 42px;
      text-align: left;
      height: 100%;
      background: transparent;
    }

    .counter {
      position: absolute;
      right: 20px;
      bottom: 10px;
      font-size: 20px;
      color: #999;
    }
  }
}
</style>
<script>
export default {
  name: 'FormTextarea',
  props: {
    value: String,
    title: String,
    subTitle: String,
    isRequire: {
      type: Boolean,
      default: false,
    },
    category: Array,
    maxlength: Number,
    showWordLimit: {
      type: Boolean,
      default: false,
    },
    type: String,
  },
  data() {
    return {
      isShow: false,
      content: '',
      selectItem: {},
    };
  },
  watch: {
    isShow(val) {
      if (val) {
        this.content = this.value || '';
      }
    },
  },
  methods: {
    onClick() {
      this.isShow = true;
    },
    chooseItem(item) {
      const selectItem = item || {};
      this.selectItem = selectItem;
      this.content = selectItem.content || '';
    },
    onBack() {
      this.isShow = false;
    },
    onSave() {
      this.$emit('input', this.content);
      this.isShow = false;
    },
    onClosed() {
      this.selectItem = {};
    },
  },
};
</script>
